import React from 'react';
import ExternalLink from '../ExternalLink';
import styled from 'styled-components';
import colors from '../../../lib/Colors';

const StyledFooter = styled.div`
  position: absolute;
  background: ${colors.white};
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  height: 60px;
`;

const StyledFooterLinkWrapper = styled.div`
  padding: 20px;
`

const Footer = () => {
  return (
    <StyledFooter>
      <StyledFooterLinkWrapper>
        <ExternalLink href={'https://www.bevspot.com/terms-conditions'} size='medium'>
          Terms of Use
        </ExternalLink>
        <ExternalLink href={'https://www.bevspot.com/privacy-policy'} size='medium'>
          Privacy Policy
        </ExternalLink>
      </StyledFooterLinkWrapper>
    </StyledFooter>
  )
};

export default Footer;
